import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Breakpoint } from '@mui/material';

type QueryType = 'up' | 'down' | 'between' | 'only';
type BreakpointOrNumber = Breakpoint | number;

export default function useResponsive(
  query: QueryType,
  key: BreakpointOrNumber,
  start?: BreakpointOrNumber,
  end?: BreakpointOrNumber
): boolean | null {
  const theme = useTheme();

  const mediaUp = useMediaQuery(theme.breakpoints.up(key as Breakpoint));
  const mediaDown = useMediaQuery(theme.breakpoints.down(key as Breakpoint));
  const mediaBetween = useMediaQuery(
    theme.breakpoints.between((start || 'xs') as Breakpoint, (end || 'xl') as Breakpoint)
  );
  const mediaOnly = useMediaQuery(
    typeof key === 'number' ? theme.breakpoints.up(key) : theme.breakpoints.only(key)
  );

  if (query === 'up') {
    return mediaUp;
  }

  if (query === 'down') {
    return mediaDown;
  }

  if (query === 'between') {
    return mediaBetween;
  }

  if (query === 'only') {
    return mediaOnly;
  }

  return null;
}
